import { Component, forwardRef, Input } from '@angular/core';
import { OptionGroup } from '../../../domain/registrator';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'app-option-group',
  imports: [
    MatRadioModule,
    MatCheckboxModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OptionGroupComponent),
      multi: true
    },
    {
      // this states that this CVA also provides validation.
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => OptionGroupComponent),
      multi: true
    }
  ],
  templateUrl: './option-group.component.html',
  styleUrl: './option-group.component.scss',
})
export class OptionGroupComponent implements ControlValueAccessor, Validator {

  @Input() group!: OptionGroup;

  value: number[] = [];
  disabled = false;

  private onChange = (value: number[]) => { };
  private onTouched = () => { };
  private onValidatorChange = () => { };

  // Called by Angular when parent writes a value
  writeValue(value: number[] | null): void {
    this.value = value ?? [];
  }

  // Called by Angular when registering change callback
  registerOnChange(fn: (value: number[]) => void): void {
    this.onChange = fn;
  }

  // Called by Angular when registering touched callback
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Validator interface - start
  validate(control: AbstractControl): ValidationErrors | null {
    if (this.group.exclusive) {
      return this.value.length === 1 ? null : { exclusiveRequired: true };
    }
    if (this.group.minAnswers && (this.value.length < this.group.minAnswers)) {
      return { minAnswersRequired: true };
    }
    if (this.group.maxAnswers && (this.value.length > this.group.maxAnswers)) {
      return { maxAnswersRequired: true };
    }
    return null;
  }

  registerOnValidatorChange?(fn: () => void): void {
    this.onValidatorChange = fn;
  }
  // Validator interface - end

  // Exclusive group → radio button
  selectExclusive(itemId: number): void {
    this.value = [itemId];
    this.onChange(this.value);
    this.onTouched();
  }

  // Non-exclusive group → checkbox
  toggleItem(itemId: number, checked: boolean): void {
    if (checked) {
      this.value = [...this.value, itemId];
    } else {
      this.value = this.value.filter(id => id !== itemId);
    }

    this.onChange(this.value);
    this.onTouched();
  }

  isChecked(itemId: number): boolean {
    return this.value.includes(itemId);
  }


}
